"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Add", {
  enumerable: true,
  get: function () {
    return _add.Add;
  }
});
Object.defineProperty(exports, "Analytics", {
  enumerable: true,
  get: function () {
    return _analytics.Analytics;
  }
});
Object.defineProperty(exports, "AssignedToMe", {
  enumerable: true,
  get: function () {
    return _assignedToMe.default;
  }
});
Object.defineProperty(exports, "BlueCaret", {
  enumerable: true,
  get: function () {
    return _blueCaret.default;
  }
});
Object.defineProperty(exports, "CSR", {
  enumerable: true,
  get: function () {
    return _iconCSR.default;
  }
});
Object.defineProperty(exports, "Calculator", {
  enumerable: true,
  get: function () {
    return _calculator.default;
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function () {
    return _calendar.default;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function () {
    return _checkbox.default;
  }
});
Object.defineProperty(exports, "CheckboxSelected", {
  enumerable: true,
  get: function () {
    return _checkboxSelected.default;
  }
});
Object.defineProperty(exports, "Checkmark", {
  enumerable: true,
  get: function () {
    return _checkmark.default;
  }
});
Object.defineProperty(exports, "CircleClose", {
  enumerable: true,
  get: function () {
    return _circleClose.CircleClose;
  }
});
Object.defineProperty(exports, "CircleDownArrow", {
  enumerable: true,
  get: function () {
    return _circleDownArrow.default;
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function () {
    return _close.Close;
  }
});
Object.defineProperty(exports, "Copy", {
  enumerable: true,
  get: function () {
    return _copy.default;
  }
});
Object.defineProperty(exports, "Cross", {
  enumerable: true,
  get: function () {
    return _cross.default;
  }
});
Object.defineProperty(exports, "Customer", {
  enumerable: true,
  get: function () {
    return _customer.Customer;
  }
});
Object.defineProperty(exports, "Customize", {
  enumerable: true,
  get: function () {
    return _customize.default;
  }
});
Object.defineProperty(exports, "Delete", {
  enumerable: true,
  get: function () {
    return _delete.default;
  }
});
Object.defineProperty(exports, "Dots", {
  enumerable: true,
  get: function () {
    return _dots.default;
  }
});
Object.defineProperty(exports, "DownArrow", {
  enumerable: true,
  get: function () {
    return _downArrow.DownArrow;
  }
});
Object.defineProperty(exports, "DownCaret", {
  enumerable: true,
  get: function () {
    return _downCaret.default;
  }
});
Object.defineProperty(exports, "Dropship", {
  enumerable: true,
  get: function () {
    return _iconDropship.default;
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function () {
    return _edit.Edit;
  }
});
Object.defineProperty(exports, "EditPen", {
  enumerable: true,
  get: function () {
    return _editPen.default;
  }
});
Object.defineProperty(exports, "Export", {
  enumerable: true,
  get: function () {
    return _export.default;
  }
});
Object.defineProperty(exports, "Eye", {
  enumerable: true,
  get: function () {
    return _eye.default;
  }
});
Object.defineProperty(exports, "FabricLogo", {
  enumerable: true,
  get: function () {
    return _fabricLogo.default;
  }
});
Object.defineProperty(exports, "FabricLogoName", {
  enumerable: true,
  get: function () {
    return _fabricLogoName.default;
  }
});
Object.defineProperty(exports, "GridView", {
  enumerable: true,
  get: function () {
    return _grid.default;
  }
});
Object.defineProperty(exports, "Help", {
  enumerable: true,
  get: function () {
    return _help.default;
  }
});
Object.defineProperty(exports, "Import", {
  enumerable: true,
  get: function () {
    return _import.default;
  }
});
Object.defineProperty(exports, "Info", {
  enumerable: true,
  get: function () {
    return _info.default;
  }
});
Object.defineProperty(exports, "LeftArrow", {
  enumerable: true,
  get: function () {
    return _leftArrow.default;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function () {
    return _link.default;
  }
});
Object.defineProperty(exports, "ListView", {
  enumerable: true,
  get: function () {
    return _list.default;
  }
});
Object.defineProperty(exports, "Lock", {
  enumerable: true,
  get: function () {
    return _lock.default;
  }
});
Object.defineProperty(exports, "LoyaltyManagement", {
  enumerable: true,
  get: function () {
    return _iconLoyaltyManagement.default;
  }
});
Object.defineProperty(exports, "Notification", {
  enumerable: true,
  get: function () {
    return _iconNotification.default;
  }
});
Object.defineProperty(exports, "OMS", {
  enumerable: true,
  get: function () {
    return _iconOms.default;
  }
});
Object.defineProperty(exports, "Offers", {
  enumerable: true,
  get: function () {
    return _iconOffers.default;
  }
});
Object.defineProperty(exports, "Overview", {
  enumerable: true,
  get: function () {
    return _iconOverview.default;
  }
});
Object.defineProperty(exports, "PIM", {
  enumerable: true,
  get: function () {
    return _iconPim.default;
  }
});
Object.defineProperty(exports, "POS", {
  enumerable: true,
  get: function () {
    return _iconPOS.default;
  }
});
Object.defineProperty(exports, "Partial", {
  enumerable: true,
  get: function () {
    return _partial.Partial;
  }
});
Object.defineProperty(exports, "Pay", {
  enumerable: true,
  get: function () {
    return _pay.Pay;
  }
});
Object.defineProperty(exports, "Play", {
  enumerable: true,
  get: function () {
    return _play.default;
  }
});
Object.defineProperty(exports, "ProductPerformance", {
  enumerable: true,
  get: function () {
    return _productPerformance.default;
  }
});
Object.defineProperty(exports, "Radio", {
  enumerable: true,
  get: function () {
    return _radio.default;
  }
});
Object.defineProperty(exports, "RadioSelected", {
  enumerable: true,
  get: function () {
    return _radioSelected.default;
  }
});
Object.defineProperty(exports, "RightArrow", {
  enumerable: true,
  get: function () {
    return _rightArrow.default;
  }
});
Object.defineProperty(exports, "RightCaret", {
  enumerable: true,
  get: function () {
    return _rightCaret.default;
  }
});
Object.defineProperty(exports, "RunningPromotions", {
  enumerable: true,
  get: function () {
    return _runningPromotions.default;
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function () {
    return _iconSearch.default;
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function () {
    return _settings.default;
  }
});
Object.defineProperty(exports, "SkuLookUp", {
  enumerable: true,
  get: function () {
    return _skuLookUp.default;
  }
});
Object.defineProperty(exports, "Subscriptions", {
  enumerable: true,
  get: function () {
    return _iconSubscriptions.default;
  }
});
Object.defineProperty(exports, "UpArrow", {
  enumerable: true,
  get: function () {
    return _upArrow.UpArrow;
  }
});
Object.defineProperty(exports, "UpCaret", {
  enumerable: true,
  get: function () {
    return _upCaret.default;
  }
});
Object.defineProperty(exports, "UserBehaviors", {
  enumerable: true,
  get: function () {
    return _userBehaviors.default;
  }
});
Object.defineProperty(exports, "WhiteDownArrow", {
  enumerable: true,
  get: function () {
    return _whiteDownArrow.default;
  }
});
Object.defineProperty(exports, "XM", {
  enumerable: true,
  get: function () {
    return _iconXm.default;
  }
});
exports.icons = void 0;

var _cross = _interopRequireDefault(require("./cross"));

var _downArrow = require("./downArrow");

var _downCaret = _interopRequireDefault(require("./downCaret"));

var _rightArrow = _interopRequireDefault(require("./rightArrow"));

var _editPen = _interopRequireDefault(require("./editPen"));

var _leftArrow = _interopRequireDefault(require("./leftArrow"));

var _whiteDownArrow = _interopRequireDefault(require("./whiteDownArrow"));

var _add = require("./add");

var _close = require("./close");

var _edit = require("./edit");

var _checkmark = _interopRequireDefault(require("./checkmark"));

var _dots = _interopRequireDefault(require("./dots"));

var _blueCaret = _interopRequireDefault(require("./blueCaret"));

var _iconSearch = _interopRequireDefault(require("./iconSearch"));

var _iconOverview = _interopRequireDefault(require("./iconOverview"));

var _iconPim = _interopRequireDefault(require("./iconPim"));

var _iconOms = _interopRequireDefault(require("./iconOms"));

var _iconXm = _interopRequireDefault(require("./iconXm"));

var _iconOffers = _interopRequireDefault(require("./iconOffers"));

var _iconLoyaltyManagement = _interopRequireDefault(require("./iconLoyaltyManagement"));

var _iconSubscriptions = _interopRequireDefault(require("./iconSubscriptions"));

var _iconDropship = _interopRequireDefault(require("./iconDropship"));

var _iconPOS = _interopRequireDefault(require("./iconPOS"));

var _fabricLogo = _interopRequireDefault(require("./fabricLogo"));

var _fabricLogoName = _interopRequireDefault(require("./fabricLogoName"));

var _skuLookUp = _interopRequireDefault(require("./skuLookUp"));

var _productPerformance = _interopRequireDefault(require("./productPerformance"));

var _userBehaviors = _interopRequireDefault(require("./userBehaviors"));

var _runningPromotions = _interopRequireDefault(require("./runningPromotions"));

var _assignedToMe = _interopRequireDefault(require("./assignedToMe"));

var _help = _interopRequireDefault(require("./help"));

var _copy = _interopRequireDefault(require("./copy"));

var _circleDownArrow = _interopRequireDefault(require("./circleDownArrow"));

var _upCaret = _interopRequireDefault(require("./upCaret"));

var _rightCaret = _interopRequireDefault(require("./rightCaret"));

var _upArrow = require("./upArrow");

var _link = _interopRequireDefault(require("./link"));

var _delete = _interopRequireDefault(require("./delete"));

var _info = _interopRequireDefault(require("./info"));

var _play = _interopRequireDefault(require("./play"));

var _calculator = _interopRequireDefault(require("./calculator"));

var _calendar = _interopRequireDefault(require("./calendar"));

var _lock = _interopRequireDefault(require("./lock"));

var _import = _interopRequireDefault(require("./import"));

var _export = _interopRequireDefault(require("./export"));

var _grid = _interopRequireDefault(require("./grid"));

var _list = _interopRequireDefault(require("./list"));

var _settings = _interopRequireDefault(require("./settings"));

var _radio = _interopRequireDefault(require("./radio"));

var _radioSelected = _interopRequireDefault(require("./radioSelected"));

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _checkboxSelected = _interopRequireDefault(require("./checkboxSelected"));

var _iconNotification = _interopRequireDefault(require("./iconNotification"));

var _circleClose = require("./circleClose");

var _customize = _interopRequireDefault(require("./customize"));

var _partial = require("./partial");

var _eye = _interopRequireDefault(require("./eye"));

var _pay = require("./pay");

var _analytics = require("./analytics");

var _customer = require("./customer");

var _iconCSR = _interopRequireDefault(require("./iconCSR"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const icons = {
  Search: _iconSearch.default
};
exports.icons = icons;